module.exports = __webpack_public_path__ + "img/mobile-contact-sw.b1c88a1a.webp";